import React, { useMemo } from 'react';

import { TeamSongCard } from '@/components/TeamSongCard';
import { useAnalyticsEvent } from '@/providers/AnalyticsProvider';

import { MessageCommonProps } from '../../RenderMessage';
import styles from './MessageSonglist.module.scss';

export type MessageGroupPosition = 'FIRST' | 'LAST' | 'MID';

type MessageSonglistProps = MessageCommonProps & {};

export const MessageSonglist = ({
	metadata,
	content,
	isAuthor,
	isSending = false,
}: MessageSonglistProps) => {
	const songIds = useMemo<string[]>(
		() => JSON.parse(metadata || '[]'),
		[metadata],
	);
	const fireViewSongEvent = useAnalyticsEvent(
		'Chat_Container_Open_View_Song',
	);

	return (
		<div className={styles['songlist']}>
			{songIds.map((id) => {
				return (
					<TeamSongCard
						key={`songlist-song-${id}`}
						light
						className={styles['song']}
						teamSongId={id}
						onClick={(teamSong) => {
							fireViewSongEvent({
								id: teamSong.id,
								title: teamSong.name,
								artist: teamSong.artist,
							});
						}}
					/>
				);
			})}
		</div>
	);
};
